import type { RouteObject } from "react-router-dom";
import { Spinner } from "@/components/ui/v2/spinner";
import { addSlashes, withCompanyPrefix } from "../route.utils";
import {
  CompanyCameraPage,
  CompanyCamerasListPage,
  CompanyCameraRecordingPage,
  CompanyCameraSettingsPage,
} from "@/utils/lazyLoadComponents";

// ─── Path Segments ────────────────────────────────────────────────────────────
export const COMPANY_CAMERA_DYNAMIC_ID_KEY = "id";

// ROOT is the platform section's key ('camera'): the sidebar links to
// company/<key>.
export enum COMPANY_CAMERA_PATH_SEGMENTS {
  ROOT = "camera",
  SETTINGS = "settings",
  DETAILS = `:${COMPANY_CAMERA_DYNAMIC_ID_KEY}`,
}

// ─── Route Definition ─────────────────────────────────────────────────────────
// Cameras module: face cameras, their recordings and recording settings. Its
// own section ('Camera'), so access is granted apart from Biometric Devices.
export const companyCameraRoutes: RouteObject = {
  path: COMPANY_CAMERA_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Cameras" },
  HydrateFallback: Spinner,
  children: [
    {
      Component: CompanyCameraPage,
      handle: { flushContent: true },
      children: [{ index: true, Component: CompanyCamerasListPage }],
    },
    // ── Module settings and the camera page — SIBLINGS of the tabs layout
    // (see routes.audit-logs.ts for the same shape). ─────────────────────────
    {
      path: COMPANY_CAMERA_PATH_SEGMENTS.SETTINGS,
      handle: { breadcrumb: "Settings", title: "Camera Settings" },
      Component: CompanyCameraSettingsPage,
    },
    {
      path: COMPANY_CAMERA_PATH_SEGMENTS.DETAILS,
      handle: { breadcrumb: "Camera", title: "Camera" },
      Component: CompanyCameraRecordingPage,
    },
  ],
};

// ─── Resolved Paths ───────────────────────────────────────────────────────────
export const COMPANY_CAMERA_PATHS = Object.freeze({
  ROOT: withCompanyPrefix(addSlashes(COMPANY_CAMERA_PATH_SEGMENTS.ROOT)),
  SETTINGS: withCompanyPrefix(
    addSlashes(
      COMPANY_CAMERA_PATH_SEGMENTS.ROOT,
      COMPANY_CAMERA_PATH_SEGMENTS.SETTINGS,
    ),
  ),
  VIEW: (id: string) =>
    withCompanyPrefix(addSlashes(COMPANY_CAMERA_PATH_SEGMENTS.ROOT, id)),
});
